import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #HEADER
\*------------------------------------ */
/**
  * 1) Global header where the navigation, logo, and other content lives across the entire site
  */
.cat-c-header {
  background: var(--cat-theme-color-background-xstrong);
  color: var(--cat-theme-color-content-brand);
  position: relative;
  width: 100%;
  height: 100%;
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-header {
    z-index: var(--cat-z-index-300);
  }
  .cat-c-header.cat-skip-link-active {
    z-index: auto;
  }
}

/**
 * Header top section
 * 1) Optional slot used for global navigation usually
 */
.cat-c-header__top {
  position: relative;
  inset-block-start: 0;
  width: 100%;
}

/**
 * Inner container of the header top section
 * 1) Used to cap the width of the content within the header
 */
.cat-c-header__top-inner {
  width: 100%;
}

/**
 * Header middle section
 * 1) Section of the site used for the logo and primary navigation
 */
.cat-c-header__middle {
  position: relative;
  width: 100%;
  box-shadow: var(--cat-theme-box-shadow-sm);
  padding-block: var(--cat-header-middle-padding-block-start) var(--cat-header-middle-padding-block-end);
}

/**
 * Header middle container
 * 1) This acts like a layout container but is flexible for different applications
 */
.cat-c-header__middle-container {
  width: 100%;
  max-width: var(--cat-header-middle-max-width);
  margin: var(--cat-header-middle-margin);
  padding-inline: var(--cat-header-middle-padding-inline-start) var(--cat-header-middle-padding-inline-end);
}

/**
 * Inner container of the header middle section
 * 1) Used to cap the width of the content within the header
 */
.cat-c-header__middle-inner {
  display: flex;
  align-items: center;
  width: 100%;
}

.cat-c-header__skip-link {
  position: fixed;
  inset-block-start: var(--cat-header-skip-link-inset-block-start, -100%);
  inset-inline-start: var(--cat-header-skip-link-inset-inline-start, var(--cat-space-medium));
  z-index: var(--cat-header-skip-link-zindex, 500);
  transition: inset-block-start 0.05s ease-in;
}

.cat-c-header__skip-link:focus-within {
  inset-block-start: var(--cat-header-skip-link-inset-block-start, var(--cat-space-medium));
}

.cat-c-header:not(.cat-c-header--has-top-slot) .cat-c-header__top, .cat-c-header:not(.cat-c-header--has-bottom-slot) .cat-c-header__bottom, .cat-c-header:not(.cat-c-header--has-skip-link-slot) [part=part-skip-link] {
  display: none;
}
`;
